import { useFormContext } from 'react-hook-form';
import {
  Grid,
  Typography,
  Divider,
  Card,
  CardContent,
  Box,
} from '@mui/material';

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <Card sx={{ mb: 3 }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>{title}</Typography>
      <Divider sx={{ mb: 2 }} />
      {children}
    </CardContent>
  </Card>
);

const Field = ({ label, value }: { label: string; value: any }) => (
  <Box mb={1}>
    <Typography variant="subtitle2">{label}</Typography>
    <Typography variant="body2" color="text.secondary">
      {value || '-'}
    </Typography>
  </Box>
);

export const Step9Review = () => {
  const { getValues } = useFormContext();
  const values = getValues();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Section title="🧍 Personal Info">
          <Field label="Full Name" value={values.fullName} />
          <Field label="Gender" value={values.gender} />
          <Field label="Date of Birth" value={values.dob} />
          <Field label="Marital Status" value={values.maritalStatus} />
          <Field label="Nationality" value={values.nationality} />
          <Field label="Blood Group" value={values.bloodGroup} />
        </Section>

        <Section title="📞 Contact Info">
          <Field label="Official Email" value={values.officialEmail} />
          <Field label="Personal Email" value={values.personalEmail} />
          <Field label="Mobile Number" value={values.mobileNumber} />
          <Field label="Alternate Contact" value={values.altContact} />
          <Field label="Present Address" value={values.presentAddress} />
          <Field label="Permanent Address" value={values.permanentAddress} />
          <Field label="City" value={values.city} />
          <Field label="State" value={values.state} />
          <Field label="Country" value={values.country} />
          <Field label="PIN Code" value={values.pinCode} />
        </Section>

        <Section title="🏢 Job Info">
          <Field label="Department" value={values.department} />
          <Field label="Designation" value={values.designation} />
          <Field label="Employment Type" value={values.employmentType} />
          <Field label="Work Mode" value={values.workMode} />
          <Field label="Date of Joining" value={values.dateOfJoining} />
          <Field label="Confirmation Date" value={values.confirmationDate} />
        </Section>

        <Section title="🕒 Attendance & Shift">
          <Field label="Shift Name" value={values.shiftName} />
          <Field label="Attendance Mode" value={values.attendanceMode} />
          <Field label="Biometric ID" value={values.biometricId} />
          <Field label="Weekly Off Days" value={values.weeklyOffDays} />
        </Section>

        <Section title="💰 Payroll">
          <Field label="CTC" value={values.ctc} />
          <Field label="Payment Mode" value={values.paymentMode} />
          <Field label="Bank Name" value={values.bankDetails?.bankName} />
          <Field label="Account Number" value={values.bankDetails?.accountNumber} />
          <Field label="IFSC Code" value={values.bankDetails?.ifsc} />
        </Section>

        <Section title="🎓 Skills & Experience">
          <Field label="Skills" value={values.skills} />
          <Field label="Certifications" value={values.certifications} />
          <Field label="Total Experience" value={values.experience?.totalYears} />
          <Field label="Relevant Experience" value={values.experience?.relevantYears} />
        </Section>

        <Section title="📂 KYC Documents">
          <Field label="Resume" value={typeof values.documents?.resume === 'string' ? 'Uploaded' : 'Not uploaded'} />
          <Field label="PAN Card" value={values.documents?.panCard?.verified ? 'Verified' : 'Not Verified'} />
          <Field label="Aadhaar Card" value={values.documents?.aadhaarCard?.verified ? 'Verified' : 'Not Verified'} />
          <Field label="Offer Letter" value={typeof values.documents?.offerLetter === 'string' ? 'Uploaded' : 'Not uploaded'} />
        </Section>

        <Section title="🆘 Emergency Contact">
          <Field label="Name" value={values.emergencyContact?.name} />
          <Field label="Number" value={values.emergencyContact?.number} />
          <Field label="Relationship" value={values.emergencyContact?.relationship} />
        </Section>
      </Grid>
    </Grid>
  );
};
